import { Link } from 'react-router-dom';
import { ReactComponent as IconKitchen } from '../assets/icons/icon-kitchens.svg';
import { ReactComponent as IconSettings } from '../assets/icons/icon-settings.svg';
import { ReactComponent as IconLocation } from '../assets/icons/icon-location.svg';
import { ReactComponent as IconClients } from '../assets/icons/icon-clients.svg';
import { ReactComponent as IconWallet } from '../assets/icons/icon-wallet.svg';
import { ReactComponent as IconModeration } from '../assets/icons/icon-moderation.svg';
import { ReactComponent as IconServices } from '../assets/icons/icon-services.svg';
import { ReactComponent as IconDevmode } from '../assets/icons/icon-devmode.svg';
import { ReactComponent as IconMoneyDoc } from '../assets/icons/icon-money-doc.svg';

const modules = [
  {
    key: 'kitchen',
    label: (<Link to='/kitchen' style={{color: 'inherit'}}>Кухни</Link>),
    icon: <IconKitchen/>,
    pages: [
      {
        key: 'kitchen/dashboard',
        label: (<Link to='/kitchen/dashboard'>Главная</Link>),
      },
      {
        key: 'kitchen/assortment',
        label: (<Link to='/kitchen/assortment'>Ассортимент</Link>),
      },
      {
        key: 'kitchen/orders',
        label: (<Link to='/kitchen/orders'>Заказы</Link>),
      },
      {
        key: 'kitchen/reviews',
        label: (<Link to='/kitchen/reviews'>Отзывы</Link>),
      },
      // Временно отключено
      // {
      //   key: 'kitchen/complaint',
      //   label: (<Link to='/kitchen/complaint'>Претензии</Link>),
      // },
      {
        key: 'kitchen/acts',
        label: (<Link to='/kitchen/acts'>Акты</Link>),
      },
      {
        key: 'kitchen/menumodifiers',
        label: (<Link to='/kitchen/menumodifiers'>Группы модификаторов</Link>),
      },
      {
        key: 'kitchen/contracts',
        label: (<Link to='/kitchen/contracts'>Договоры</Link>),
      },
    ],
  },
  {
    key: 'settings',
    label: (<Link to='/settings' style={{color: 'inherit'}}>Настройки</Link>),
    icon: <IconSettings/>,
    pages: [
      {
        key: 'settings/kitchensettings',
        label: (<Link to='/settings/kitchensettings'>Основные</Link>),
      },
      {
        key: 'settings/notWorkingDays',
        label: (<Link to='/settings/notWorkingDays'>Нерабочие дни</Link>),
      },
      {
        key: 'settings/adminsettings',
        label: (<Link to='/settings/adminsettings'>Для админа</Link>),
      },
      {
        key: 'settings/profile',
        label: (<Link to='/settings/profile'>Профиль</Link>),
      },
    ],
  },
  {
    key: 'delivery',
    label: (<Link to='/delivery' style={{color: 'inherit'}}>Управление доставкой</Link>),
    icon: <IconLocation/>,
    pages: [
      {
        key: 'delivery/map',
        label: (<Link to='/delivery/map'>Карта с курьерами</Link>),
      },
      {
        key: 'delivery/services',
        label: (<Link to='/delivery/services'>Службы доставки</Link>),
      },
      {
        key: 'delivery/courierspayments',
        label: (<Link to='/delivery/courierspayments'>Начисления курьеров</Link>),
      },
      {
        key: 'delivery/paymentsLists',
        label: (<Link to='/delivery/paymentsLists'>Платежные поручения</Link>),
      },
      {
        key: 'delivery/monitoringdocuments',
        label: (<Link to='/delivery/monitoringdocuments'>Мониторинг документов</Link>),
      },
      {
        key: 'delivery/admindocuments',
        label: (<Link to='/delivery/admindocuments'>Документы админов</Link>),
      },
    ],
  },
  {
    key: 'clients',
    label: (<Link to='/clients' style={{color: 'inherit'}}>Клиенты</Link>),
    icon: <IconClients/>,
    pages: [
      {
        key: 'clients/search',
        label: (<Link to='/clients/search'>Поиск клиентов</Link>),
      },
      {
        key: 'clients/orders',
        label: (<Link to='/clients/orders'>Заказы</Link>),
      },
      {
        key: 'clients/notifications',
        label: (<Link to='/clients/notifications'>Уведомления</Link>),
      },
      {
        key: 'clients/addresses',
        label: (<Link to='/clients/addresses'>Адреса</Link>),
      },
      {
        key: 'clients/generateAuthCodes',
        label: (<Link to='/clients/generateAuthCodes'>Генерация кодов авторизации</Link>),
      },
    ],
  },
  {
    key: 'finance',
    label: (<Link to='/finance' style={{color: 'inherit'}}>Маркетинг и Финансы</Link>),
    icon: <IconWallet/>,
    pages: [
      {
        key: 'finance/wallets',
        label: (<Link to='/finance/wallets'>Кошельки</Link>),
      },
      {
        key: 'finance/promocodes',
        label: (<Link to='/finance/promocodes'>Промокоды</Link>),
      },
      {
        key: 'finance/corpclients',
        label: (<Link to='/finance/corpclients'>Корпоративные клиенты</Link>),
      },
      {
        key: 'finance/organizationscatalog',
        label: (<Link to='/finance/organizationscatalog'>Организации</Link>),
      },
    ],
  },
  {
    key: 'accounting',
    label: (<Link to='/accounting' style={{color: 'inherit'}}>Бухгалтерия и финансы</Link>),
    icon: <IconMoneyDoc/>,
    pages: [
      {
        key: 'accounting/reports',
        label: (<Link to='/accounting/reports'>Отчёты</Link>),
      },
      {
        key: 'accounting/integration',
        label: (<Link to='/accounting/integration'>Интеграция с 1С</Link>),
        disabled: true,
      },
      {
        key: 'accounting/kitchenspayments',
        label: (<Link to='/accounting/kitchenspayments'>Выплаты кухням</Link>),
      },
      {
        key: 'accounting/paymentslists',
        label: (<Link to='/accounting/paymentslists'>Платежные поручения</Link>),
      },
      {
        key: 'accounting/summarysales',
        label: (<Link to='/accounting/summarysales'>Сводные продажи</Link>),
      },
      {
        key: 'accounting/actsGeneratingLogs',
        label: (<Link to='/accounting/actsGeneratingLogs'>Генерация актов</Link>),
      },
    ],
  },
  {
    key: 'moderation',
    label: (<Link to='/moderation' style={{color: 'inherit'}}>Модерация</Link>),
    icon: <IconModeration/>,
    pages: [
      {
        key: 'moderation/products',
        label: (<Link to='/moderation/products'>Модерация товаров</Link>),
      },
      {
        key: 'moderation/reviews',
        label: (<Link to='/moderation/reviews'>Модерация отзывов</Link>),
      },
    ],
  },
  {
    key: 'services',
    label: (<Link to='/services' style={{color: 'inherit'}}>Настройки сервиса</Link>),
    icon: <IconServices/>,
    pages: [
      {
        key: 'services/rightsmanagement',
        label: (<Link to='/services/rightsmanagement'>Права</Link>),
      },
      {
        key: 'services/adminpanelnews',
        label: (<Link to='/services/adminpanelnews'>Новости</Link>),
      },
      {
        key: 'services/adminpanelstories',
        label: (<Link to='/services/adminpanelstories'>Сторизы</Link>),
      },
      {
        key: 'services/categories',
        label: (<Link to='/services/categories'>Категории</Link>),
      },
      {
        key: 'services/componentsdirectory',
        label: (<Link to='/services/componentsdirectory'>Компоненты</Link>),
      },
      {
        key: 'services/roleaccess',
        label: (<Link to='/services/roleaccess'>Компоненты для ролей</Link>),
      },
      {
        key: 'services/methodsdirectory',
        label: (<Link to='/services/methodsdirectory'>Методы</Link>),
      },
      {
        key: 'services/rolemethods',
        label: (<Link to='/services/rolemethods'>Методы для ролей</Link>),
      },
      {
        key: 'services/entitysettings',
        label: (<Link to='/services/entitysettings'>Сущности</Link>),
      },
      {
        key: 'services/filemanager',
        label: (<Link to='/services/filemanager'>Файлы</Link>),
      },
      {
        key: 'services/apps',
        label: (<Link to='/services/apps'>Приложения</Link>),
      },
      {
        key: 'services/citiescatalog',
        label: (<Link to='/services/citiescatalog'>Города</Link>),
      },
      {
        key: 'services/notificationlogs',
        label: (<Link to='/services/notificationlogs'>PUSH-уведомления</Link>),
      },
    ],
  },
  {
    key: 'documentation',
    label: (<Link to='/documentation' style={{color: 'inherit'}}>Разработчикам</Link>),
    icon: <IconDevmode/>,
    pages: [
      {
        key: 'documentation/errorlogs',
        label: (<Link to='/documentation/errorlogs'>Логи ошибок</Link>),
      },
      {
        key: 'documentation/adminpaneldocs',
        label: (<Link to='/documentation/adminpaneldocs'>К админ-панели</Link>),
      },
      {
        key: 'documentation/graphqldocs',
        label: (<Link to='/documentation/graphqldocs'>GraphQL</Link>),
      },
    ],
  },
];

export default modules;
